module.exports = __webpack_public_path__ + "assets/images/rijeka_2020.png";